<template>
  <section>
    <h2 class="h2Title">제품 관리</h2>
    <div class="dashWrap">

      <div class="dashRow">
        <h2 class="tit">분류 목록</h2>
        <div class="dashBx">
          <categories @callback-clicked="selectCategory"/>
        </div>
      </div>

      <div class="dashRow">
          <h2 class="tit">
            <span>{{categoryName}} 제품 목록</span>
          </h2>

          <div class="dashBx">

            <article class="fieldMb">
<!--              <form class="fieldWrap">-->
                <div class="fieldBx">
                  <ul>
                    <li class="formList">
                      <dl>
                        <dd>
                          <v-col sm="12" class="d-flex">

                            <v-spacer />

                            <v-text-field
                                v-model="searchQuery"
                                append-icon="mdi-magnify"
                                @click:append="getProducts"
                                solo
                                rounded
                                hide-details
                                dense
                                clearable
                                placeholder="제품 검색"
                                @keyup.enter="getProducts"
                            ></v-text-field>

                            <v-btn
                                :loading="isLoading"
                                icon
                                small
                                class="ml-2"
                                @click="reloadSearch"
                            >
                              <v-icon>mdi-refresh</v-icon>
                            </v-btn>


                          </v-col>
                        </dd>
                      </dl>

                    </li>
                  </ul>
                </div>
<!--              </form>-->
            </article>

            <article class="tableWrap">
              <div class="tableBtnBx">
                <p class="searchAll">
                </p>
                <div class="tableBtn">
                  <ul>
                    <li class="tableBtnList">
                      <v-btn color="primary" class="vBtn vIconResize mgr" @click="$router.push({path:'/product/form'})">
                        <v-icon class="mr-2">mdi mdi-playlist-plus</v-icon>
                        제품 추가
                      </v-btn>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="tableBx">
                <v-data-table
                    :headers="headers"
                    :items="products"
                    class="flex-grow-1"
                    :server-items-length="totalItems"
                    :options.sync="options"
                    item-key="productId"
                    :footer-props="{showFirstLastPage: true}"
                    disable-sort
                >
                  <template v-slot:item.productId="{ item }">
                    {{item.productId}}
                    <!--              <div class="font-weight-bold"># <copy-label :text="item.userId + ''" /></div>-->
                  </template>
                  <template v-slot:item.primaryImageFile="{ value }">
                    <v-img
                        :src="value ? `/attachment/product/${value}` : `/attachment/product/${value}`"
                        v-on:error.once="value='/photo_default.jpg'"
                        aspect-ratio="1"
                        class="grey lighten-2 white--text align-end"
                        gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
                        max-width="200"
                    />
                  </template>

                  <template v-slot:item.category="{ value }">
                    {{value.categoryName}}

                    <!--              <div class="font-weight-bold"># <copy-label :text="item.userId + ''" /></div>-->
                  </template>
                  <template v-slot:item.price="{ value }">
                    {{ value | numeralFormat('0,000') }}
                  </template>


                  <template v-slot:item.productName="{ item }">
                    <div class="d-flex align-center py-1">
                      <div class="ml-1 caption font-weight-bold">
                        <router-link :to="{path:`/product/detail/${item.productId}`}">{{item.productName}}</router-link>
                      </div>
                    </div>
                  </template>

                  <template v-slot:item.createdAt="{ value }">
                    <div>{{ value | moment('YYYY-MM-DD HH:mm:ss') }}</div>
                  </template>

<!--                  <template v-slot:item.stock="{ value }">-->
<!--                    <div>{{ value | numeralFormat('0,000') }}</div>-->
<!--                  </template>-->

                </v-data-table>
              </div>
            </article>

          </div>


        </div>
      </div>

  </section>
</template>

<script>
import Categories from './components/Categories'
import ProductApi from "@/api/ProductApi"

export default {
  name: 'products',
  components: {
    Categories,
  },
  data() {
    return {
      isLoading: false,

      searchQuery: '',
      waitingSearch: false,

      param:{},
      headers: [
        // { text: 'ID', align: 'left', value: 'productId' },
        { text: '상품 이미지', align: 'center', value: 'primaryImageFile' },
        { text: '분류', align: 'left', value: 'category' },
        { text: '제품명', align: 'left', value: 'productName' },
        { text: '가격', value: 'price' },
        { text: '생성일', value: 'createdAt' },
        // { text: '재고', value: 'stock' },
        // { text: '', sortable: false, align: 'right', value: 'action' }
      ],
      options:{},
      totalItems: 0,
      products: [],
      selectedProducts: [],
      categoryName: ''
    }
  },
  watch: {
    options: {
      handler() {
        this.getProducts();
      },
      deep: true,
    },
    searchQuery: {
      handler(nv) {
        this.param.searchKeyword = nv;
        if (!this.waitingSearch) {
          setTimeout(() => {
            this.getProducts();
            this.waitingSearch = false;
          }, 500); // 0.5 sec delay
        }
        this.waitingSearch = true;
      }
    },
  },
  methods: {
    selectCategory(v) {
      if(v.categoryId === 1) {
        this.param.searchCategory = null;
        this.categoryName = '';
      } else {
        this.categoryName = v.categoryName;
        this.param.searchCategory = v.categoryId;
      }
      this.getProducts();
    },
    reloadSearch() {
      this.param = {}
      this.searchQuery = ''
      this.getProducts();
    },
    getProducts() {
      const {  page, itemsPerPage, size } = this.options;
      let params = {...this.param, ...{
          page: page,
          size: size ? size : itemsPerPage
        }};
      if (this.param.searchDate?.length??0 > 0) {
        params.fromDate = this.param.searchDate[0];
        params.toDate = this.param.searchDate?.[1]??this.param.searchDate[0];
      } else {
        params.fromDate = null;
        params.toDate = null;
      }

      // console.log(params);
      ProductApi.list(params).then(data => {
        this.totalItems = data.totalElements;
        this.products = data.content;
      })
    },
    /* eslint no-unused-vars: 0 */
    getCategory(node) {
      // console.log(node)
    }
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.dashWrap {
  display: flex;
  flex-flow: row wrap;
}

.dashRow:first-child {
  flex: 0 1 25%;

  &:first-child {
    margin-right: 2%;
  }
}
.dashRow:nth-child(2) {
  flex: 0 1 70%;

}

.tit {
  margin-top: 30px;
  margin-left: 5px;
  margin-bottom: 10px;
  font-size: 18px;
}

.dashBx {
  padding: 20px;
  border: 1px solid #e9e9e9;

  .state {
    padding-top: 37px;
    padding-bottom: 37px;
    cursor: pointer;
    color: #666;

    dt {
      display: flex;
      justify-content: center;
      align-items: baseline;
      margin-bottom: 20px;

      em {
        margin-right: 5px;
        font-size: 50px;
        font-weight: bold;
        color: #333;
      }
    }

    dd {
      font-weight: 500;
    }
  }

  .deposit {
    display: flex;
    padding: 0;

    li {
      display: flex;
      justify-content: space-between;
      flex: 0 0 38%;

      &:nth-child(3) {
        flex: 0 0 24%;
      }

      .depositTit {
        width: 100px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #ccc;
        border-radius: 25px;
        background: #f6f6f6;
        font-size: 13px;
        font-weight: 600;
        color: #555;
        text-align: center;
      }

      .depositNum {
        display: flex;
        padding-top: 50px;
        padding-right: 30px;

        p {
          margin-right: 50px;

          em {
            font-size: 40px;
            font-weight: bold;
          }
        }
      }
    }
  }

}

.h3Title {
  @include h3-title;
}

.fieldWrap {
  @include form-bx;

  .fieldBx {
    position: relative;
    //width: 1600px;

    .searchBtn {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 1.7%;
    }

    .formList {
      display: flex;
      flex-direction: row;
      margin-bottom: 10px;

      dl {
        display: flex;
        align-items: center;
        flex-direction: row;
        margin-right: 20px;

        .formTit {
          @include form-font;
        }

        dd {
          display: flex;
          align-items: center;

          span {
            margin-left: 8px;
          }

          &:nth-child(2) {
            padding-left: 5px;
            padding-bottom: 3px;
          }

          .monthBx {
            display: flex;
            align-items: center;
            height: 35px;
            border-radius: 3px;
            border: 1px solid #1867c0;

            .month {
              &:first-child {
                padding-left: 10px;
              }

              height: 100%;
              padding: 0 8px;
              border: 0;
              background: #fff;
              font-size: 13px;
              font-weight: normal;
              color: #1867c0;

              &.active {
                background: #1867c0;
                color: #fff;
              }
            }
          }
        }
      }
    }
  }
}
.tableWrap {
  .tableBtnBx {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .searchAll {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      /*font-size: 13px;*/
      .txtPoint {
        color: $point-color;
      }
    }
  }

  .tableBtn {
    ul {
      display: flex;
      flex-direction: row;
      align-items: center;

      .tableBtnList {
        //margin-right: 15px;
      }
    }
  }
}
</style>